export default function SvgLabelPrinting() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 33.3 40">
      <path d="M14.4,26.3H30v10.5H14.4C14.4,36.8,14.4,26.3,14.4,26.3z M18.6,35.8h10.3v-8.4H15.5v8.4H18.6z" />
      <path d="M14.4,14.7H30v10.5H14.4C14.4,25.3,14.4,14.7,14.4,14.7z M18.6,24.2h10.3v-8.4H15.5v8.4H18.6z" />
      <path
        d="M6.7,26.3c-2,0-4.4-5.3-4.4-12.1S4.7,2.1,6.7,2.1s4.4,5.3,4.4,12.1S8.6,26.3,6.7,26.3L6.7,26.3z M11.1,26.3
	h-0.9c0.3-0.4,0.7-1,0.9-1.5V26.3z M33.3,37.9h-20V13.7l0,0C13.2,8.8,12,4.5,10.2,2.1h16.5c2,0,4.4,5.3,4.4,12.1v23.7L33.3,37.9
	V14.2c0-7.8-3-14.2-6.7-14.2h-20C3,0,0,6.4,0,14.2s3,14.2,6.7,14.2h4.4V40h22.2V37.9L33.3,37.9z"
      />
      <path
        d="M7.2,17.1c-0.2,0.3-0.3,0.5-0.5,0.7c-0.1,0.1-0.1,0.1-0.1,0.1s0,0-0.1-0.1c-0.2-0.1-0.3-0.4-0.5-0.7
	c-0.3-0.7-0.6-1.8-0.6-2.9s0.2-2.2,0.6-2.9c0.2-0.3,0.3-0.6,0.5-0.7c0.1-0.1,0.1-0.1,0.1-0.1s0,0,0.1,0.1c0.2,0.1,0.3,0.4,0.5,0.7
	c0.3,0.7,0.6,1.8,0.6,2.9S7.6,16.4,7.2,17.1 M6.7,9.5c-1.2,0-2.2,2.1-2.2,4.7s1,4.7,2.2,4.7s2.2-2.1,2.2-4.7S7.9,9.5,6.7,9.5"
      />
      <path
        d="M15.6,12.6c0-3.2-0.5-5.5-1.7-8.4h12.2c1.5,2.2,2.6,5,2.8,8.4H15.6L15.6,12.6z M12.2,3.2
	c1.4,3.1,2.4,5.8,2.2,10.5H30c0-5.2-1.9-8.7-3.3-10.5H12.2L12.2,3.2z"
      />
    </svg>
  );
}
